import { List, Create, Edit, View, MyPending } from "../Components/index.js";

export default [
    {
        path: "/fd/note-sheet",
        component: List,
        name: "fd.note-sheet",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/note-sheet/create",
        component: Create,
        name: "fd.note-sheet.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/note-sheet/:id/edit",
        component: Edit,
        name: "fd.note-sheet.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/note-sheet/:id/view",
        component: View,
        name: "fd.note-sheet.view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/note-sheet-my-pending",
        component: MyPending,
        name: "fd-my-note-sheet",
        meta: {
            requiresAuth: true,
        },
    },
];
